import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center -mb-12 sm:-mb-20 lg:-mb-[104px] ruler">
      <Helmet>
      <title>404 - Page Not Found | YourWebsiteName</title>
    </Helmet>
      <h1 className="text-6xl font-extrabold text-gray-800 mb-4">404</h1>
      <p className="text-xl md:text-2xl text-gray-600 mb-6">
        Oops! The page you are looking for does not exist.
      </p>
      <button
        onClick={() => navigate("/")}
        className="px-6 py-3 bg-orangebg bg-btnhover flex items-center text-white rounded-[12px] shadow-md"
      >
        
      Go Back Home
      </button>
      
    </div>
  );
};

export default NotFound;